export default "__VITE_ASSET__1dzhGd67__"